module.exports = __webpack_public_path__ + "static/media/estate-clarity-mockup-6.9f6a90a5.jpg";